// formReducer.js
const initialState = {
    certType: '',
    phoneNumber: '',
    nationalId: '',
    birthDate: '',
    uniqueData: '',
    timeStamp:''
};

const FirstInfoReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_FIRST_INFO':
            return {
                ...state,
                phoneNumber: action.payload.phoneNumber,
                nationalId: action.payload.nationalId,
                birthDate: action.payload.birthDate,
            };
        case 'SET_CERT_TYPE':
            return {
                ...state,
                certType: action.payload.certType,
            };
        case 'SET_UNIQUE_DATA':
            return {
                ...state,
                uniqueData: action.payload.uniqueData
            };
        case 'SET_TIME_STAMP':
            return {
                ...state,
                timeStamp: action.payload.timeStamp
            };
        case 'RESET_CERTIFICATE_FLOW':
            return initialState;
        default:
            return state;
    }
};

export default FirstInfoReducer;
